import { render, staticRenderFns } from "./UserCenterWareEnd.vue?vue&type=template&id=2604f776&scoped=true"
import script from "./UserCenterWareEnd.vue?vue&type=script&lang=js"
export * from "./UserCenterWareEnd.vue?vue&type=script&lang=js"
import style0 from "./UserCenterWareEnd.vue?vue&type=style&index=0&id=2604f776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604f776",
  null
  
)

export default component.exports